import {chunk} from 'lodash'

export const toggleItemInArray = (array, item) =>
    array.indexOf(item) >= 0
        ? array.filter(i => i !== item)
        : [...array, item]

export const reorderItems = (items, fromIndex, toIndex) => {
    const ret = [
        ...items.slice(0, fromIndex),
        ...items.slice(fromIndex + 1),
    ]
    ret.splice(toIndex, 0, items[fromIndex])
    return ret
}

export const capItems = (items, maxItems) => {
    return items.length > maxItems
        ? items.slice(0, maxItems)
        : items
}

export const createBatches = (items, maxBatchSize) => {
    return chunk(items, maxBatchSize)
}
